<template>
  <SplitContainer21 ref="refSplitContainer21" style="height:100%" :layout="12">
    <template #top>
      <TableMain ref="vendInitPurchaseQuoteTable2" :show_query_container="true" :isBusy="isBusy_table2"
        :fields="invent_fields" :show_date_picker="true" :table_height_adjust="-8" :title="table_title.title2"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false" :pager_count="5"
        :loading_width="100" @on_query="invent_query" tableref="1f2b9fa42e48447dba36c4b7c3b7cdc5">
        <template #query>
          {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 200px"
            v-model="ItemId"></el-input>
          {{ $t("common.invent") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
            v-model="NameAlias"></el-input>
        </template>
      </TableMain>
    </template>
    <template #bottom>
      <TableMain ref="vendInitPurchaseQuoteTable3" :fields="item_fileds" :show_query_container="false"
        :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="-1"
        :show_filter="false" :show_pagination="show_pagination" :pager_count="5"
        :hb_table_class="'hb_table_viq_out_class2'" :isBusy="isBusy_table3" :loading_width="50"
        @state_change="table3_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]" @on_input="table3_on_input"
        @on_change="table3_on_input" tableref="6d94e1ef75d9493794d41f575d9330da">
        <template #toolbar="">
          <el-select filterable clearable reserve-keyword multiple collapse-tags placeholder="供应商选择"
            :filter-method="remoteVenderMethod" class="ml-2" v-model="venders" style="width: 30rem"
            @clear="remoteVenderMethod" @remove-tag="remoteVenderMethod(venders)" @focus="remoteVenderMethod('')">
            <!-- <el-option-group v-for="group in vender_options" :key="group.label" :label="group.label">
              <el-option v-for="item in group.options" :key="item.AccountNum" :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum">
              </el-option>
            </el-option-group> -->
            <el-option v-for="item in vender_options" :key="item.AccountNum"
              :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum">
            </el-option>
          </el-select>
          <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddVendPurchaseQuote"><i
              class="fa fa-plus"></i></el-button>
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveData"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </template>
  </SplitContainer21>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import Vue from "vue"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as VendTableController from "../../controllers/base/VendTableController"
import * as commonController from '../../controllers/commonController'
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as VendInitialQuoteController from "../../controllers/sd/VendInitialQuoteController"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer21 from "../components/container/SplitContainer21"
import TableDetail from "../components/table/TableDetail"
import TableMain from "../components/table/TableMain"

export default {
  name: "VendPurchaseQuoteOutAdd",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer21,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_vend_purch_price",
        title2: "table_invent",
        title3: "table_vend_price_create_initail",
      },
      fields: VendInitialQuoteController.fields.default,
      invent_fields: _.cloneDeep(VendInitialQuoteController.fields.invent_fields),
      item_fileds: _.cloneDeep(VendInitialQuoteController.fields.item_fileds),
      dataForm: _.cloneDeep(VendInitialQuoteController.dataForm),
      show_pagination: false,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      AccountNum: "",
      ItemId: "",
      SEI_Name: "",
      NameAlias: "",
      vender_options: [],
      vender_search_options: [],
      venders: [],
      all_purchase: [],
      vend_currency_his: [],
      invent_retail_options: [],
    }
  },
  computed: {
    venders_data() {
      return this.$store.state.biz_data.baseData.Vender
    },
  },
  watch: {
    venders_data(a, b) {
      this.getOptions()
    },
  },
  activated() { },
  deactivated() { },
  created() {
    let _this = this
    let _field = _.find(this.item_fileds, { key: "CurrencyCode" })
    _field["_options"] = {
      base_on_field: "AccountNum",
      provider: (v) => {
        return _.map(_this.$store.state.biz_data.baseData.Currency, (v) => {
          return {
            value: v.CurrencyCode,
            label: v.CurrencyCode + ": " + v.Txt,
          }
        })
      },
      // provider: (v) => {
      //   return _.map(_this.setCurrencyData(v), (v) => {
      //     return {
      //       value: v.CurrencyCode,
      //       label: v.CurrencyCode + ": " + v.Txt,
      //     };
      //   });
      // },
    }
    let _field1 = _.find(this.item_fileds, {
      key: "RetailVariantId",
    })
    _field1["_options"] = {
      base_on_field: "ItemId",
      provider: (v) => {
        return _.map(_this.setInventData(v), (t) => {
          return {
            value: t.RetailVariantId,
            label: t.RetailVariantId + "：" + t.VariantName,
          } //VariantName
        })
      },
    }
    let _field3 = _.find(this.item_fileds, {
      key: "TaxGroup",
    })
    _field3["_options"] = {
      base_on_field: "AccountNum",
      provider: (v) => {
        let list = _.map(_this.$store.state.biz_data.baseData.TaxGroupHeading, (t) => {
          return {
            value: t.TaxGroup,
            label: t.TaxGroup + ":" + t.TaxGroupName,
          }
        })
        // let list = _.map(_.filter(_this.$store.state.biz_data.baseData.AllVender, { AccountNum: v }), (t) => {
        //   let m = _.find(_this.$store.state.biz_data.baseData.TaxGroupHeading, { TaxGroup: t.TaxGroup })
        //   if (m) {
        //     return {
        //       value: m.TaxGroup,
        //       label: m.TaxGroup + ":" + m.TaxGroupName,
        //     };
        //   }
        // });
        return _.uniqBy(list, "value")
      },
    }
  },
  mounted() {
    this.$refs.refSplitContainer21.split_setting2 = 0.5
    this.getOptions()
  },
  methods: {
    ///获取物料相关信息
    async getInventData(_itemId) {
      if (_.isNull(_itemId)) {
        return
      }
      let _result = await InventTableController.methods.getItemData({
        // ItemId: { "=": _itemId }
        ItemId: _itemId,
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = _.filter(_result[0], (t) => {
          return t.RetailVariantId != ""
        })
        let _p = {
          ItemId: _itemId,
          options: _list,
        }
        let _index = _.findIndex(this.invent_retail_options, (t) => {
          return t.ItemId == _p.ItemId
        })
        if (_index < 0) {
          this.invent_retail_options.push(_p)
        }
      }
    },
    ///变形编号
    setInventData(_itemId) {
      let _m = _.find(this.invent_retail_options, { ItemId: _itemId })
      if (_m) {
        return _m.options
      }
      return []
    },
    ///设置币种选项
    setCurrencyData(_AccountNum) {
      let _list = []
      _.each(this.vend_currency_his, (t) => {
        let _m = _.find(this.$store.state.biz_data.baseData.Currency, {
          CurrencyCode: t.Currency
        })
        if (_m && t.AccountNum == _AccountNum) {
          let _index = _.findIndex(_list, { CurrencyCode: _m.CurrencyCode })
          if (_index < 0) {
            _list.push(_m)
          }
        }
      })
      return _.cloneDeep(_list)
    },

    //预加载部分options
    getOptions() {
      let vender_list = []
      let companyInfoList = _.map(this.$store.state.biz_data.baseData.CompanyInfo, "VenderAccountNum")
      _.each(this.$store.state.biz_data.baseData.Vender, (t) => {
        if (!_.includes(companyInfoList, t.AccountNum)) {
          vender_list.push(t)
        }
      })
      this.vender_options = _.cloneDeep(
        _.orderBy(
          vender_list,
          ["AccountNum"],
          ["asc"]
        )
      ).splice(0, 300)
      this.vender_search_options = _.cloneDeep(
        _.orderBy(
          vender_list,
          ["AccountNum"],
          ["asc"]
        )
      ).splice(0, 300)
    },

    //#region Table1
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      let _fromDate = "",
        _toDate = ""
      let _params = {
        SEI_Name: { like: "%" + this.SEI_Name + "%", "<>": "" },
      }
      if (this.ItemId != "") {
        _params.ItemId = { "=": this.ItemId }
      }
      if (!_.isNull(date_range) && this.ItemId == "" && this.SEI_Name == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      let _result = await VendInitialQuoteController.methods.getData(
        _params
      )

      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0].Result.Data[0], ["id"], ["desc"]))
      }
      this.all_purchase = _.orderBy(
        _result[2].Result.Data[0],
        ["id"],
        ["desc"]
      )
      this.isBusy_table1 = false
    },
    ///状态切换
    state_change(data, cb) {
      if (data && data.state === "deleted") {
        if (data.selected_items.length > 0) {
          let _check_del_list = []
          _.each(data.selected_items, function (t) {
            if (t.is_approved) {
              _check_del_list.push(t.id)
            }
          })
          if (_check_del_list.length > 0) {
            this.msgToasts(
              "编号：" + _.join(_check_del_list, "，") + "，已审批不能删除！"
            )
            return
          }
          this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
            if (v) {
              let result =
                await VendInitialQuoteController.methods.deleteData(
                  data.selected_items
                )
              if (result) {
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
              }
            }
          })
        }
      } else if (data.state === "approved" || data.state === "unapproved") {
        let _msg = data.state == "approved" ? "审批" : "反审"
        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            let _list = _.cloneDeep(data.selected_items)
            _.each(_list, (t) => {
              t.is_approved = data.state == "approved" ? true : false
            })
            let result =
              await VendInitialQuoteController.methods.approveData(_list)
            if (result) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'VendInitialQuoteAdd', data, this)
              cb(true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
          else {
            await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, 'VendInitialQuoteAdd', data, this)
          }
        })
      }
    },
    ///print
    tool_invoke() { },
    //#endregion

    //#region Table2
    ///查询物料
    async invent_query(set_data, date_range) {
      let has_privilige = commonController.methods.checkPrivilige(this, "z-OutsideVendQuote", "外部供应商报价操作权限")
      if (!has_privilige) {
        set_data([])
        return
      }
      this.isBusy_table2 = true
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      _params.NameAlias = this.NameAlias
      _params.ItemId = this.ItemId
      if (!_.isNull(date_range) && this.NameAlias == "" && this.ItemId == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params.fromDate = _fromDate
        _params.toDate = _toDate
      }

      set_data([])
      let _result = await InventTableController.methods.getItemData(_params)

      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.uniqBy(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]), "ItemId")
        set_data(dt)
      }
      this.isBusy_table2 = false
    },

    //#endregion

    //#region Table3
    //添加供应商采购报价
    async AddVendPurchaseQuote() {
      this.isBusy_table3 = true
      //this.$refs.vendInitPurchaseQuoteTable3.SetData([]);
      let _select_invent_list =
        this.$refs.vendInitPurchaseQuoteTable2.GetSelectedItems()
      if (_select_invent_list.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        this.isBusy_table3 = false
        return
      }

      if (this.venders.length == 0) {
        this.msgToasts(this.$t("common.action_select") + this.$t("common.provider"), "info")
        this.isBusy_table3 = false
        return
      }

      let _this = this
      if (this.venders.length > 0) {
        let _list = []
        _.each(_select_invent_list, async (m) => {
          _.each(this.venders, (t) => {
            let _t = _.cloneDeep(_this.dataForm)
            for (var i in _t) {
              _t[i] = _.cloneDeep(m)[i]
            }
            console.log(t)
            _t.id = ""
            _t.AccountNum = t
            //取供应商默认币种
            let _vt = _.find(this.$store.state.biz_data.baseData.Vender, {
              AccountNum: t,
            })
            _t.SEI_Name = _vt.SEI_Name
            _t.CurrencyCode = _vt.Currency
            _t.TaxGroup = _vt.TaxGroup

            _t.FromDate = new Date()
            _t.ToDate = this.$date.addMonths(new Date(), 12)
            _list.push(_t)
          })
          ///查询相关变形编号
          await this.getInventData(m.ItemId)
        })
        if (this.$refs.vendInitPurchaseQuoteTable3.my_data.length > 0) {
          this.$refs.vendInitPurchaseQuoteTable3.AppendItems(
            _.orderBy(_list, ["ItemId"], ["desc"])
          )
        } else {
          this.$refs.vendInitPurchaseQuoteTable3.SetData(
            _.orderBy(_list, ["ItemId"], ["desc"])
          )
        }

        ///获取选中供应商的非sei的供应商
        let _result = await VendTableController.methods.getItemData({
          AccountNum: { in: this.venders },
        })
        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.vend_currency_his = _result[0]
        }
      }
      this.isBusy_table3 = false
    },
    //供应商选择
    remoteVenderMethod(query) {
      if (_.isArray(query)) {
        if (query.length == 0) query = ""
        else return
      }
      let vender_list = []
      let companyInfoList = _.map(this.$store.state.biz_data.baseData.CompanyInfo, "VenderAccountNum")
      let all_vend_list = _.uniqBy(_.filter(this.$store.state.biz_data.baseData.AllVender, (t) => t.Blocked === "否"), "AccountNum")
      _.each(all_vend_list, (t) => {
        if (!_.includes(companyInfoList, t.AccountNum)) vender_list.push(t)
      })
      if (query && query !== "") {
        this.loadingSelected1 = true
        let _filter_list = _.orderBy(
          vender_list,
          ["AccountNum"],
          ["asc"]
        ).filter((item) => {
          return (
            item.AccountNum.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
            item.SEI_Name.indexOf(query) > -1
          )
        })
        this.vender_options = _.cloneDeep(_filter_list).splice(0, 300)
        this.loadingSelected1 = false
      } else {
        let data = _.cloneDeep(
          _.orderBy(
            vender_list,
            ["AccountNum"],
            ["asc"]
          )
        ).splice(0, 300)
        this.vender_options = data
      }
    },
    Calc_Cost_Sum(data) {
      let sum = 0
      if (data.EXP != undefined) {
        sum += data.EXP
      }
      if (data.M11 != undefined) {
        sum += data.M11
      }
      if (data.M12 != undefined) {
        sum += data.M12
      }
      if (data.M22 != undefined) {
        sum += data.M22
      }
      if (data.M23 != undefined) {
        sum += data.M23
      }
      if (data.M24CTP != undefined) {
        sum += data.M24CTP
      }
      if (data.M25 != undefined) {
        sum += data.M25
      }
      if (data.M26 != undefined) {
        sum += data.M26
      }
      if (data.O11 != undefined) {
        sum += data.O11
      }
      if (data.O12 != undefined) {
        sum += data.O12
      }
      if (data.O23 != undefined) {
        sum += data.O23
      }
      if (data.O24 != undefined) {
        sum += data.O24
      }
      if (data.O25 != undefined) {
        sum += data.O25
      }
      if (data.O26 != undefined) {
        sum += data.O26
      }
      if (data.S11 != undefined) {
        sum += data.S11
      }
      if (data.X != undefined) {
        sum += data.X
      }
      if (data.Y != undefined) {
        sum += data.Y
      }
      if (data.Z != undefined) {
        sum += data.Z
      }
      if (sum != 0) {
        data.Cost_Sum = sum
      }
    },
    ///保存
    async saveData(cb) {
      let _this = this
      let _list = _.cloneDeep(this.$refs.vendInitPurchaseQuoteTable3.my_data)
      if (_list.length > 0) {
        let _is_check_ok = await this.ValidData()
        if (_is_check_ok == false) {
          cb(false)
          return
        }
        let _items = []
        _.each(_list, (t) => {
          let _data = _.cloneDeep(t)
          delete _data._current
          delete _data._id
          delete _data._selected
          let _m = _.find(_this.$store.state.biz_data.baseData.Vender, {
            AccountNum: _data.AccountNum,
          })
          if (_m) {
            _data.SEI_Name = _m.SEI_Name
          }

          ///变形名称
          let _mr = _.find(this.invent_retail_options, {
            ItemId: _data.ItemId,
          })

          if (_mr) {
            let _t = _.find(_mr.options, {
              RetailVariantId: _data.RetailVariantId,
            })
            if (_t) {
              _data.VariantName = _t.VariantName
            }
          }

          if (_.isDate(_data.FromDate)) {
            _data.FromDate = _this.$date.format(_data.FromDate, "yyyy-MM-dd")
          }
          if (_.isDate(_data.ToDate)) {
            _data.ToDate = _this.$date.format(_data.ToDate, "yyyy-MM-dd")
          }
          //计算cost_sum
          // this.Calc_Cost_Sum(_data);
          _data.create_by_username = this.$global.global_data.local_username
          _items.push(_data)
        })

        ///保存数据
        let _rel_save_data = await VendInitialQuoteController.methods.saveData(_items)
        cb(true)
        if (!_.isNull(_rel_save_data)) {
          ///成功
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          let _dt = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/i/") > -1
          })

          //新增
          let _rel_items = []
          if (_dt && _dt.length > 0) {
            _.each(_dt, (t) => {
              _rel_items = _.union(_rel_items, t.Result.Data[0])
            })

            this.$refs.vendInitPurchaseQuoteTable3.SetData([])
            this.dataForm = _.cloneDeep(
              VendInitialQuoteController.dataForm
            )
          }

          //修改
          let _update_list = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/u/") > -1
          })
          if (_update_list && _update_list.length > 0) {
            _.each(_update_list, (t) => {
              let _ul = t.Result.Data[0]
              _.each(_ul, (m) => {
                this.$refs.vendInitPurchaseQuoteTable3.UpdateItems({ id: m.id }, m)

                let this_ = this
                let items = _.filter(this_.all_purchase, { id: m.id })
                _.each(items, (d) => {
                  _.each(m, (v, k) => {
                    Vue.set(d, k, v)
                  })
                })
              })
            })
          }
          this.venders = []
        } else {
          ///失败
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      } else {
        cb(true)
      }
    },
    ///保存前检查
    async ValidData() {
      ///检查数量
      let _list = _.cloneDeep(this.$refs.vendInitPurchaseQuoteTable3.my_data)
      let _index = _.findIndex(_list, function (t) {
        if (t.QuantityAmountFrom == 0 && t.QuantityAmountTo == 0) {
          return t
        }
      })
      // if (_index > -1) {
      //   this.msgToasts("开始数量和结束数量不能同时为0或空！", "info");
      //   return false;
      // }
      _index = _.findIndex(_list, function (t) {
        if (!_.isNull(t.QuantityAmountFrom) && !_.isNull(t.QuantityAmountTo)) {
          if (t.QuantityAmountFrom > t.QuantityAmountTo) {
            return t
          }
        }
      })
      if (_index > -1) {
        this.msgToasts(this.$t("notify.vend_price_start_must_can_not_lg_end"), "info")
        return false
      }

      ///检查价格(不能为空、0或者小于0)
      let _price_list = _.cloneDeep(this.$refs.vendInitPurchaseQuoteTable3.my_data)
      let _price_index = _.findIndex(_price_list, function (t) {
        if (isNaN(t.Amount) || _.isNull(t.Amount)) {
          return t
        }
      })
      if (_price_index > -1) {
        this.msgToasts(this.$t("notify.vend_price_not_null"), "info")
        return false
      }
      return true
    },

    ///del item
    table3_state_change(data, cb) {
      if (data.state == "deleted") {
        if (
          data.selected_items.length == 1 &&
          _.isInteger(data.selected_items[0].id)
        ) {
          this.msgToasts(this.$t("notify.not_supply"), "info")
        } else {
          this.$refs.vendInitPurchaseQuoteTable3.RemoveItems(data.selected_items)
        }
      }
    },
    table3_on_input: _.debounce(
      async function (data) {

        let _this = this
        if (data.field.key == "Amount" || data.field.key == "TaxGroup" || data.field.key == "CurrencyCode") {
          if (data.item.Amount && data.item.Amount != "") {
            ///获取含税价格和非含税价格
            let _price_tax = {
              currency: data.item.CurrencyCode,
              amount: data.item.Amount,
              incTax: 1,
              taxGroup: data.item.TaxGroup
            }
            let _cnyAmount_m =
              await SalesOrderController.methods.getLocalAmountWOTaxData(
                _price_tax
              )
            if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
              if (!_.isNull(_cnyAmount_m[0][0].CNYAmount)) {
                data.item.AmountWOTax = _cnyAmount_m[0][0].CNYAmount
              }
              if (!_.isNull(_cnyAmount_m[0][0].CNYAmountWOTax)) {
                data.item.AmountWOTax = _cnyAmount_m[0][0].CNYAmountWOTax
              }
            }
          }
        }
      },
      200,
      { leading: false, trailing: true }
    ),
    //#endregion
  },
}
</script>
<style>
.hb_table_vpq_out_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 130rem;
}

.hb_table_viq_out_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 135rem;
}

.tdCLass {
  width: 100px;
}
</style>
<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
